<template>
	<div class="detail-card">
		<div class="detail-card__content">
			<div class="title">
				<slot name="title"></slot>
			</div>

			<div v-if="headContent" class="head">
				<div>{{ headContent.name }}</div>
				<div>{{ headContent.value }}</div>
			</div>

			<div
				v-if="detailContent"
				class="detail"
				:class="{ 'is-large': detailLarge }"
			>
				<dl v-for="data in detailContent" :key="data.id">
					<dt>{{ data.name }}</dt>
					<dd>{{ data.value }}</dd>
				</dl>
			</div>

			<div v-if="isContentSlot" class="detail">
				<slot name="content"></slot>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		title: {
			type: String,
			default: '',
		},
		titleClass: {
			type: String,
			default: '',
		},
		headContent: {
			type: Object,
			default: null,
		},
		detailContent: {
			type: Array,
			default: null,
		},
		detailLarge: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		isContentSlot() {
			return this.$slots.content ? true : false;
		},
	},
};
</script>

<style scoped>
.detail-card {
	padding: 0.25rem;
}

.detail-card__content {
	border-radius: 0.1875rem;
	border: 1px solid #c8c8c8;
	background: #fff;
}

.detail-card__content .title {
	display: flex;
	align-items: center;
	height: 3em;
	padding: 0 0.75rem;
	background: #ededed;
	font-size: 0.8125rem;
	font-weight: 300;
}

.detail-card__content .title .complete {
	color: #384ef5;
}

.detail-card__content .title .cancel {
	color: #f53838;
}

.detail-card__content .head {
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 3em;
	padding: 0 0.75rem;
	border-bottom: 1px solid #c8c8c8;
	font-size: 0.875rem;
	font-weight: 500;
}

.detail-card__content .detail {
	padding: 1rem;
}

.detail-card__content .detail dl {
	display: flex;
	flex-flow: row wrap;
	justify-content: space-between;
}

.detail-card__content .detail dt,
.detail-card__content .detail dd {
	padding: 0.25em 0;
	font-size: 0.875rem;
	letter-spacing: -0.05em;
}

.detail-card__content .detail dt {
	flex: 0 0 2.5rem;
	color: #666;
	font-weight: 300;
}

.detail-card__content .detail dd {
	flex: 0 0 calc(100% - 2.5rem);
	font-weight: 500;
}

.detail-card__content .detail.is-large dt {
	flex: 0 0 5.625rem;
}

.detail-card__content .detail.is-large dd {
	flex: 0 0 calc(100% - 5.625rem);
}
</style>
